import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { configSlice } from './configSlice';
import { loginSlice } from '../login/loginSlice';
import { langSlice } from '../lang/langSlice';
import { tokenSlice } from '../token-handling/tokenSlice';
import { appSlice } from '../../data/appSlice';
import { transportExecutionApi } from '../../services/transport-execution/transportExecution.api';
import { shipmentsOverviewSlice } from '../../features/shipments-overview/redux/shipmentsOverview.slice';
import { shipmentTransferOptionsSlice } from '../../features/confirm-shipment-transfer/redux/shipmentTransferOptions.slice';

// Create the root reducer independently to obtain the RootState type
const rootReducer = combineReducers({
    config: configSlice.reducer,
    lang: langSlice.reducer,
    app: appSlice.reducer,
    login: loginSlice.reducer,
    tokenHandling: tokenSlice.reducer,
    [shipmentsOverviewSlice.reducerPath]: shipmentsOverviewSlice.reducer,
    [shipmentTransferOptionsSlice.reducerPath]: shipmentTransferOptionsSlice.reducer,
    [transportExecutionApi.reducerPath]: transportExecutionApi.reducer,
});

export const getStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,

        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(transportExecutionApi.middleware),
    });

export const store = getStore();

// Infer the store, state and dispatch types from the store instance
export type RootState = ReturnType<typeof rootReducer>;
export type RootStore = ReturnType<typeof getStore>;
export type AppDispatch = RootStore['dispatch'];

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
